<!--
	MonoLabel — the mono-caps label primitive (02 §3, §6): section indices
	("01 / SCAN"), form labels, trust lines. Styling lives in the `.mono-label`
	class (app.css); this component is the semantic wrapper.
-->
<script lang="ts">
	import type { Snippet } from 'svelte';

	let {
		children,
		class: klass = ''
	}: {
		children: Snippet;
		class?: string;
	} = $props();
</script>

<span class="mono-label {klass}">{@render children()}</span>
